import React, { useEffect, useState, useRef  } from "react";
import AdminHeading from "../AdminPanel/Heading/AdminHeading";
import AdminBreadCrump from "../AdminPanel/Heading/AdminBreadCrump";
import CredtitPeriodTable from "Components/support/customervendor/CreditPeriodTable";
// import "../PagesStyles/AdminMasters.css";
import style from "./CreditPeriodNew.module.css";
import { Icon } from "@iconify/react";
import { TbCircleNumber1 } from "react-icons/tb";
import {
  a100,
  a104,
  a107,
  a108,
  a109,
  a110,
  a111,
  a112,
  a119,
  a120,
  a121,
  a122,
  a123,
  a124,
  a125,
  a126,
  a127,
  a18,
  a207,
  a208,
  a209,
  a210,
  a211,
  a212,
  a213,
  a214,
  a215,
  a35,
  a7,
  a95,
  a96,
  a97,
  a98,
  a99,
} from "../../Api/RootApiPath";
import { useSelector } from "react-redux";
import { RiListUnordered, RiPlayListAddLine } from "react-icons/ri";
import AlertMessage from "../../Other Functions/AlertMessage";
export default function CreditPeriodNew() {
  const [active, setActive] = useState("AddNew");
  const [showError, setShowError] = useState(false);
  const [messageType, setMessageType] = useState("");
  const [messageToShow, setMessageToShow] = useState("");
  const [loading, setLoading] = useState(false);

  const [allCategories, setAllCategories] = useState([]);
  const [newCategory, setNewCategory] = useState({
    CreditPeriod: "",

    ClientCode: "",
    CompanyId: 0,
    CounterId: 0,
    BranchId: 0,
    OldEntry: false,
  });
  const [allCompaniesList, setAllCompaniesList] = useState([]);
  const [allBranchesList, setAllBranchesList] = useState([]);
  const [allDepartmentsList, setAllDepartmentsList] = useState([]);
  const [allRolesList, setAllRolesList] = useState([]);
   const [searchInput, setSearchInput] = useState("");
  
    const handleSearchChange = (event) => {
      setSearchInput(event.target.value);
    };
    const handleSearchSubmit = () => {
      // You can handle the search logic here
      console.log("Searching for:", searchTerm);
    };
  const inputRef = useRef();
  const allStates = useSelector((state) => state);
  const adminLoggedIn = allStates.reducer1;
  //   let Entryby_Staff_id = parseInt(adminLoggedIn);
  const clientCode = adminLoggedIn.ClientCode;
  const employeeCode = adminLoggedIn.EmployeeCode;
  const CompanyId = adminLoggedIn.CompanyId;
  const BranchId = adminLoggedIn.BranchId;
  const CounterId = adminLoggedIn.CounterId;
  const EmployeeId = adminLoggedIn.EmployeeId;

  useEffect(() => {
    window.scroll(0, 0);
  }, []);
  const fetchAllCategory = async () => {
    const formData = {
      ClientCode: clientCode,
    };
    const response = await fetch(a213, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(formData),
    });
    const data = await response.json();
    console.log(data, "data,");
    try {
      if (data.length > 0) {
        setAllCategories(data);
      } else {
        setActive("addNew");
        document
          .getElementById("addCategoryListTitle")
          .classList.add("activeCategoryTitle");
        document
          .getElementById("addCategoryListLogo")
          .classList.add("activeCategoryLogo");
        document.getElementById("addCategoryListTitle").click();
      }
    } catch (error) {
      console.log(error);
    }
  };
  useEffect(() => {
    fetchAllCategory();
  }, []);
  const fetchAllCompanies = async () => {
    const formData = {
      ClientCode: clientCode,
    };
    const response = await fetch(a95, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(formData),
    });
    const data = await response.json();
    console.log(data, "data,");
    try {
      if (data.length > 0) {
        setAllCompaniesList(data);
      } else {
        // alert("Please Add Company First");
      }
    } catch (error) {
      console.log(error);
    }
  };
  useEffect(() => {
    fetchAllCompanies();
  }, []);

  const fetchAllBranches = async () => {
    const formData = {
      ClientCode: clientCode,
    };
    const response = await fetch(a98, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(formData),
    });
    const data = await response.json();
    console.log(data, "data,");
    try {
      if (data.length > 0) {
        setAllBranchesList(data);
      } else {
        // alert("Please Add Company First");
      }
    } catch (error) {
      console.log(error);
    }
  };
  useEffect(() => {
    fetchAllBranches();
  }, []);

  const fetchAllDepartments = async () => {
    const formData = {
      ClientCode: clientCode,
    };
    const response = await fetch(a104, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(formData),
    });
    const data = await response.json();
    console.log(data, "data,");
    try {
      if (data.length > 0) {
        setAllDepartmentsList(data);
      } else {
        // alert("Please Add Company First");
      }
    } catch (error) {
      console.log(error);
    }
  };
  useEffect(() => {
    fetchAllDepartments();
  }, []);

  const fetchAllRoles = async () => {
    const formData = {
      ClientCode: clientCode,
    };
    const response = await fetch(a107, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(formData),
    });
    const data = await response.json();
    console.log(data, "data,");
    try {
      if (data.length > 0) {
        setAllRolesList(data);
      } else {
        // alert("Please Add Company First");
      }
    } catch (error) {
      console.log(error);
    }
  };
  useEffect(() => {
    fetchAllRoles();
  }, []);
  console.log(allCategories, "allCategories");
  console.log(allCompaniesList, "allCompaniesList");
  console.log(allDepartmentsList, "allDepartmentsList");
  console.log(allBranchesList, "allBranchesList");
  console.log(allRolesList, "allRolesList");

  const handleNewCategoryChange = (e) => {
    const { name, value } = e.target;
    // Update the edited data in the state
    setNewCategory({ ...newCategory, [name]: value });
  };
  console.log(newCategory, "newCategory");
  console.log(newCategory, "newCategory");

  const addNewCategory = async (e) => {
    e.preventDefault();
    setLoading(true);
    const formData = {
      ClientCode: clientCode,
      CreditPeriod: newCategory.CreditPeriod || "0",

      CompanyId: CompanyId ? CompanyId : 0,
      CounterId: CounterId ? CounterId : 0,
      BranchId: BranchId ? BranchId : 0,

      ...(newCategory.OldEntry ? { Id: newCategory.Id } : {}),
    };
    console.log(formData, "formData to send");
    try {
      const response = await fetch(
        !newCategory.OldEntry ? a214 : a215,
        // a96,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(formData),
        }
      );
      const data = await response.json();

      fetchAllCategory();
      setActive("List");
      setNewCategory({
        CreditPeriod: "",
        ClientCode: "",
        CompanyId: 0,
        CounterId: 0,
        BranchId: 0,
        OldEntry: false,
      });
      if (data.message) {
        // alert(data.message);
        setMessageType("error");
        setMessageToShow(data.message);
        setShowError(true);
        setActive("AddNew");
      } else {
        setMessageType("success");
        setMessageToShow("Credit Period Added Successfully");
        setShowError(true);
      }
      setLoading(false);
      console.log(data);
    } catch (error) {
      console.error(error);
    }
  };

  useEffect(() => {
    setTimeout(() => {
      setShowError(false);
    }, 2000);
  }, [showError]);
  const handleEditData = (data) => {
    console.log(data, "data");
    console.log(data, "data");
    console.log(data, "data");
    setNewCategory({ ...data, OldEntry: true });
    setActive("AddNew");
  };
  return (
    <div>
      <AdminHeading />
      <div className="adminMainBodyBox">
        {showError ? (
          <AlertMessage message={messageToShow} type={messageType} />
        ) : null}
        <AdminBreadCrump
          title={"Add Customer Credit Period"}
          companyName={"Loyalstring"}
          module={"Settings"}
          page={"Customer Credit Period"}
        />
        {active == "List" ? (
          <>
            <div style={{ padding: "16px" }}>
              <div className={style["white-space"]}>
                <div className={style["icon-div"]}>
                  <div className={style["search-container"]}>
                    <input
                      type="text"
                      value={searchInput}
                      onChange={handleSearchChange}
                      placeholder="Search..."
                      className={style["serach-input"]}
                    />
                    <button
                      style={{ margin: 0 }}
                      className={style["search-btn"]}
                      onClick={handleSearchSubmit}
                    >
                      <Icon style={{ fontSize: "20px" }} icon="mdi:magnify" />
                    </button>
                  </div>
                  <Icon
                    style={{
                      alignSelf: "center",
                      marginTop: "0px !important",
                      fontSize: "28px ",
                      color: "#0077d4",
                      cursor: "pointer",
                    }}
                    icon="bx:export"
                  />
                  <button
                    style={{  marginTop: "0px !important" }}
                    className={style["custom-btn"]}
                  >
                    <Icon
                      style={{ fontSize: "24px " }}
                      icon="ic:outline-print"
                    />
                    Print
                  </button>
                  <button
                    onClick={() => {
                      setActive("AddNew");
                    }}
                    style={{ marginTop: "0px !important" }}
                    className={style["custom-btn"]}
                  >
                    <Icon icon="line-md:plus" width="24" height="24" />
                     New
                  </button>
                </div>
              </div>

              <CredtitPeriodTable
                // columns={columns}
                allCategories={allCategories}
                handleEditData={handleEditData}
                searchInput={searchInput}
                setSearchInput={setSearchInput}
              />
            </div>
          </>
        ) : (
          <>
            <div className={style.adminAddCategoryMainBox}>
              <div className={style.adminAddCategoryInnerBox}>
                <div className="adminAddCategoryInnerBoxTitlesBox"></div>

                <div
                  style={{ marginTop: "0px" }}
                  className={
                    active !== "List"
                      ? "adminCategoryAddCategoryMainBox"
                      : "none"
                  }
                >
                  {/* <p>Add New Customer Credit Period</p> */}
                  <form onSubmit={addNewCategory}>
                    <div
                      style={{
                        gridTemplateColumns: "repeat(4,1fr)",
                        columnGap: "40px",
                        minHeight: "50px",
                        marginTop: "30px",
                        marginBottom: "20px",
                      }}
                      className="adminCategoryAddCategoryInnerBox"
                    >
                      <label>
                        Credit Period (in Days)<sup>*</sup>
                      </label>
                      <input
                       ref={inputRef} 
                        name="CreditPeriod"
                        value={newCategory.CreditPeriod}
                        onChange={handleNewCategoryChange}
                        type="number"
                        required="required"
                        placeholder="Enter Number of Days"
                      />
                    </div>
                    {!loading ? (
                      <div
                        style={{ marginBottom: "20px" }}
                        className={style["btn-container"]}
                      >
                        <button style={{ marginTop: "20px", marginTop: "0px" }}>
                          <Icon width="24px" icon="ic:sharp-check" /> Submit
                        </button>
                        <button
                          onClick={() => {
                            // Resetting the input field value to an empty string
                            setNewCategory({ CreditPeriod: "" });
                            // Optionally, you can also clear the input field visually by accessing the DOM directly using useRef
                            inputRef.current.value = "";
                          }}
                          style={{
                            marginTop: "0px",
                            display: "flex",
                            height: "32px",
                            justifyContent: "center",
                            alignItems: "center",
                            borderRadius: "5px",
                            background: "#fff",
                            color: "#0077d4",
                            border: "1px solid #0077d4",
                            cursor: "pointer",
                          }}
                        >
                          <Icon
                            width="24px"
                            icon="ix:reset"
                            style={{ color: "#0077D4" }}
                          />{" "}
                          Reset
                        </button>
                        <button
                          style={{ marginTop: "20px", marginTop: "0px" }}
                          onClick={() => {
                            setActive("List");
                          }}
                        >
                          <Icon width="24px" icon="fluent:list-rtl-16-filled" />{" "}
                          List
                        </button>
                      </div>
                    ) : null}
                  </form>
                </div>
              </div>
            </div>
          </>
        )}
      </div>
    </div>
  );
}
